<template>
    <div class="footer">
        <div class="footer-content">
            <div class="logo-section">
                <div class="logo">
                    <img src="../assets/home28.png" alt="">
                </div>
                <div class="company-name">
                    深圳雾曼科技有限公司
                </div>
            </div>
            <div class="contact-address">
                <div class="section-title">联系地址</div>
                <div class="address-info">
                    营销中心：深圳市北方大厦
                </div>
                <div class="address-info">
                    联合实验室、试制中心：深圳市松山湖
                </div>
            </div>
            <div class="about-section">
                <div class="section-title">关于雾曼</div>
                <div class="section-info" style="cursor: pointer;" @click="navigateToDynamic">
                    雾曼空间
                </div>
            </div>
            <div class="contact-section">
                <div class="section-title">联系雾曼</div>
                <div class="section-info">
                    0755-29422829
                </div>
                <div class="section-info">
                    137 1379 8717
                </div>
            </div>
            <div style="display: flex; ">
                <div class="qrcode-section">
                    <div class="qrcode">
                        <img src="../assets/home29.png" alt="">
                    </div>
                    <div class="qrcode-text">雾曼官网</div>
                </div>
                <div class="qrcode-section">
                    <div class="qrcode">
                        <img src="../assets/home30.png" alt="">
                    </div>
                    <div class="qrcode-text">企业微信</div>
                </div>
            </div>
        </div>
        <div class="icp-info">Copyright © 2021 Wm All Rights Reserved. <a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备2021158512号-4</a></div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    methods: {
        navigateToDynamic() {
            this.$router.push('/dynamic').then(() => {
                window.scrollTo(0, 0);
            });
        }
    },
}
</script>

<style scoped>
.footer {
    background: #F5F6F7;
    height: 238px;
    position: relative;
}

.footer-content {
    margin: auto;
    padding: 34px 0;
    display: flex;
    width: calc(997px + 345px);
}

.logo-section .logo {
    width: 344px;
    height: 44px;
}

.company-name {
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    padding: 16px 0 0 0;
}

.contact-address {
    padding: 0 0 0 87px;
}

.about-section {
    padding: 0 0 0 67px;
}

.contact-section {
    padding: 0 0 0 87px;
}

.section-title {
    font-size: 15px;
    font-weight: 600;
    color: #000000;
}

.address-info,
.section-info {
    font-size: 13px;
    color: #6D7278;
    font-weight: 400;
    margin: 16px 0 0 0;
}

.qrcode-section {
    padding: 0 0 0 71px;
}

.qrcode-section:last-child {
    padding: 0 0 0 62px;
}

.qrcode {
    width: 113px;
    height: 113px;
}

.qrcode-text {
    font-size: 13px;
    color: #000000;
    font-weight: 400;
    width: 113px;
    text-align: center;
}

.icp-info {
    position: absolute;
    bottom: 10px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #6D7278;
}

/* 添加移动端适配样式 */
@media screen and (max-width: 768px) {
    .footer {
        height: auto;
        padding-bottom: 30px;
    }

    .footer-content {
        width: 100%;
        flex-direction: column;
        padding: 30px 20px;
    }

    .logo-section .logo {
        width: 200px;
        height: auto;
    }

    .contact-address,
    .about-section,
    .contact-section,
    .qrcode-section {
        padding: 20px 0 0 0;
    }

    .qrcode-section:last-child {
        padding: 20px 0 0 100px;
    }

    .qrcode {
        /* margin: 0 auto; */
    }

    .company-name {
        padding: 10px 0 0 0;
    }

    .icp-info {
        position: relative;
        margin-top: 20px;
    }
}
</style>
